// Dependent optical values and complete quotations move together.
export const CATALOGUE_GROUPS = [
  { id: 'name', label: 'Display name', fields: ['name'] },
  { id: 'optics', label: 'Optical configuration', fields: ['resW', 'resH', 'sensorW', 'focal', 'fmin', 'fmax', 'pano', 'publishedHfov', 'publishedVfov', 'details.opticsMode', 'details.opticalProfiles', 'details.sensorModules', 'details.corridor'] },
  { id: 'installation', label: 'Body and installation', fields: ['type', 'environment', 'mount', 'ir', 'lpr', 'power', 'powerW', 'dimensions', 'details.mounting', 'details.accessories'] },
  { id: 'quote', label: 'Planning quotation', fields: ['cost', 'currency', 'supplier', 'priceDate'] },
  { id: 'evidence', label: 'Sources and verification', fields: ['datasheetUrl', 'verifiedAt', 'specStatus', 'details.provenance', 'details.lifecycle', 'details.sourceRevision'] },
  { id: 'recording', label: 'Recording and saved quotes', fields: ['details.recording', 'details.quotes'] }
];
const get = (o, p) => p.split('.').reduce((v, k) => v?.[k], o) ?? null;
const put = (o, p, v) => { const keys = p.split('.'); let t = o; for (const k of keys.slice(0, -1)) t = t[k] ||= {}; t[keys.at(-1)] = structuredClone(v); };
export const groupValue = (m, group) => Object.fromEntries(group.fields.map(p => [p, get(m, p)]));
export const sameDefinition = (a, b) => JSON.stringify(a) === JSON.stringify(b);

export function mergeCamera(base, local, incoming, choices = {}, preservePrices = true) {
  const model = structuredClone(local), groups = [];
  for (const group of CATALOGUE_GROUPS) {
    const before = base ? groupValue(base, group) : null, here = groupValue(local, group), there = groupValue(incoming, group);
    if (sameDefinition(here, there)) continue;
    const localChanged = !base || !sameDefinition(here, before), incomingChanged = !base || !sameDefinition(there, before);
    const conflict = localChanged && incomingChanged;
    const suggested = group.id === 'quote' && preservePrices ? 'local' : !localChanged && incomingChanged ? 'incoming' : 'local';
    const choice = ['local', 'incoming'].includes(choices[group.id]) ? choices[group.id] : suggested;
    groups.push({ id: group.id, label: group.label, base: before, local: here, incoming: there, conflict, choice, localChanged, incomingChanged });
    if (choice === 'incoming') for (const field of group.fields) put(model, field, get(incoming, field));
  }
  // A locally retained optical configuration cannot acquire the incoming
  // manufacturer's verification claim merely by merging evidence separately.
  const optical = groups.find(g => g.id === 'optics');
  if (optical && optical.choice === 'local' && optical.localChanged) {
    model.specStatus = local.specStatus === 'verified' ? 'unverified' : local.specStatus;
    const evidence = CATALOGUE_GROUPS.find(g => g.id === 'evidence');
    for (const field of evidence.fields.filter(p => p !== 'specStatus')) put(model, field, get(local, field));
    const comparison = groups.find(g => g.id === 'evidence');
    if (comparison) {
      comparison.choice = 'local';
      comparison.forced = true;
      comparison.note = 'Verification stays with the local optical configuration. Choose incoming optics to use its manufacturer verification.';
    }
  }
  return { model, groups };
}
